<template>
    <div>
        <b-modal id="create-or-update-contact" size="lg" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <firm-create-or-update-contact :editing="editing" v-model="contact" :communication-languages="communicationLanguages" :occupation-titles="occupationTitles" :firm-contact-types="firmContactTypes"  :locations="locations"></firm-create-or-update-contact>
            <template #modal-footer>
                <v-executer :editing="editing" :loading="loading" :action="createOrUpdate"></v-executer>
            </template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    name="firm-contact-table"
                    :add-callback="createNew"
                    pagination="server"
                    search
                    :buttons="buttons"
                    :fields="fields"></v-table>
    </div>
</template>

<script>
import FirmOperationsApi from '@/api/firm-operations'
import SystemDataApi from '@/api/system-data'
import FirmCreateOrUpdateContact from '@/views/firm-operations/firm/components/FirmCreateOrUpdateContact.vue'
import UserApi from '@/api/user'

export default {
    components:{
        FirmCreateOrUpdateContact,
    },
    props:{
        firm:Object,
    },
    data(){
        return{
            fields:[
                { name:"Lokasyon Adı",key:"FirmLocationName",tdClass:"text-nowrap", thClass:"w-10",sortable:true,sortKey:'FirmLocation.LocationName'},
                { name:"Ad",key:"FirstName",tdClass:"text-nowrap", thClass:"w-10",sortable:true},
                { name:"Soyad",key:"LastName",tdClass:"text-nowrap", thClass:"w-10",sortable:true},
                { name:"Unvan",key:"OccupationTitle",tdClass:"text-nowrap", thClass:"w-10",sortable:true,sortKey:'OccupationTitle.Name'},
                { name:"E-Posta",key:"Email",tdClass:"text-nowrap", thClass:"w-10",sortable:true},
                { name:"Cep Telefonu",key:"MobilePhone",tdClass:"text-nowrap", thClass:"w-10",sortable:true},
                { name:"Telefon",key:"Phone",tdClass:"text-nowrap", thClass:"w-10",sortable:true},
                { name:"Dahili",key:"InternalNumber",tdClass:"text-nowrap", thClass:"w-5",sortable:true},
                { name:"İletişim Dili",key:"CommunicationLanguageName",tdClass:"text-nowrap", thClass:"w-10",sortable:true,sortKey:'CommunicationLanguage.Name'},
                { name:"Operasyon Sorumlusu",key:"OperationsManager",tdClass:"text-nowrap", thClass:"w-10",sortable:true},
                { name:"Muhasebe Sorumlusu",key:"AccountingManager",tdClass:"text-nowrap", thClass:"w-10",sortable:true},
                { name:"Satın Alma Sorumlusu",key:"PurchasingManager",tdClass:"text-nowrap", thClass:"w-10",sortable:true},
                { name:"Finansman Sorumlusu",key:"FinanceOfficer",tdClass:"text-nowrap", thClass:"w-10",sortable:true},
                { name:"Teklif Sorumlusu",key:"OfferOfficer",tdClass:"text-nowrap", thClass:"w-10",sortable:true},
            ],
            buttons:[
                { text:"Kullanıcı Oluştur",key:'create-user',icon:"UserPlusIcon",variant:"success",action:this.createUser,condition:(item)=> !item.IsHaveUser },
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"primary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            communicationLanguages:[],
            occupationTitles:[],
            firmContactTypes:[],
            locations:[],
            editing:false,
            loading:false,
            contact:{
                Id:null,
                FirmId:this.firm.Id,
                FirmLocation:null,
                FirmLocationId:null,
                CommunicationLanguage:null,
                CommunicationLanguageId:null,
                Email:null,
                Phone:null,
                MobilePhone:null,
                InternalNumber:null,
                OperationsManager:false,
                AccountingManager:false,
                PurchasingManager:false,
                FinanceOfficer:false,
                OfferOfficer:false,
                ContactType:null,
                ContactTypeId:null,
                FirstName:null,
                LastName:null,
                OccupationTitle:null,
                OccupationTitleId:null
            }
        }
    },
    mounted(){
        this.getCommunicationLanguages()
        this.getOccupationTitles()
        this.getLocations()
    },
    methods:{
        clearForm(){
            this.editing = false
            this.contact.Id = null
            this.contact.FirmLocation = null
            this.contact.FirmLocationId = null
            this.contact.CommunicationLanguage = null
            this.contact.CommunicationLanguageId = "11e1ec79-dc35-41b3-8a5a-5eaeaf0848cc"/*DEFAULT TR*/,
            this.contact.Email = null
            this.contact.Phone = null
            this.contact.MobilePhone = null
            this.contact.InternalNumber = null
            this.contact.OperationsManager = false
            this.contact.AccountingManager = false
            this.contact.PurchasingManager = false
            this.contact.FinanceOfficer = false
            this.contact.OfferOfficer = false
            this.contact.ContactType = null
            this.contact.ContactTypeId = null
            this.contact.FirstName = null
            this.contact.LastName = null
            this.contact.OccupationTitle = null
        },
        createNew(){
            this.clearForm()
            this.$showModal("create-or-update-contact")
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.$refs.table.rowLoading(true)
            FirmOperationsApi.Contact.Get(item.Id).then(res=>{
                this.contact.Id = item.Id
                this.contact.FirmLocationId = res.data.Data.FirmLocationId
                this.contact.CommunicationLanguageId = res.data.Data.CommunicationLanguageId
                this.contact.Email = res.data.Data.Email
                this.contact.Phone = res.data.Data.Phone
                this.contact.InternalNumber = res.data.Data.InternalNumber
                this.contact.MobilePhone = res.data.Data.MobilePhone
                this.contact.OperationsManager = res.data.Data.OperationsManager
                this.contact.AccountingManager = res.data.Data.AccountingManager
                this.contact.PurchasingManager = res.data.Data.PurchasingManager
                this.contact.FinanceOfficer = res.data.Data.FinanceOfficer
                this.contact.OfferOfficer = res.data.Data.OfferOfficer
                this.contact.ContactTypeId = res.data.Data.ContactTypeId
                this.contact.FirstName = res.data.Data.FirstName
                this.contact.LastName = res.data.Data.LastName
                this.contact.OccupationTitleId = res.data.Data.OccupationTitleId
                this.$showModal('create-or-update-contact')
                this.$refs.table.rowLoading(false)
            }).catch(err=>{
                this.$refs.table.rowLoading(false)
                this.$result(null,err)
            })
        },
        getCommunicationLanguages(){
            SystemDataApi.CommunicationLanguage().then(res=>{
                this.communicationLanguages = res.data.Data
            })
        },
        createOrUpdate(){
            this.loading = true
            FirmOperationsApi.Contact.CreateOrUpdate(this.editing,this.contact).then(res=>{
                this.loading = false
                this.$result(res)
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$emit('refresh')
                    this.$hideModal("create-or-update-contact")
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${this.firm.Name} firmasına ait ${item.FirmLocationName} isimli lokasyonun ${item.Value} iletişim bilgisini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    FirmOperationsApi.Contact.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                            this.$emit('refresh')
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
        getLocations(){
            FirmOperationsApi.Location.List(this.firm.Id).then(res=>{
                this.locations = res.data.Data
            })
        },
        getOccupationTitles(){
            SystemDataApi.OccupationTitle().then(res=>{
                this.occupationTitles = res.data.Data
            })
        },
        getFirmContactTypes(){
            SystemDataApi.FirmContactType().then(res=>{
                this.firmContactTypes = res.data.Data
            })
        },
        createUser(item){
            this.$refs.table.rowLoading(true)
            UserApi.CreateCustomerUser(item.Id).then(res=>{
                if(res.data.Success){
                    this.$refs.table.refresh()
                }
                this.$result(res)
                this.$refs.table.rowLoading(false)
            }).catch(err=>{
                this.$result(null,err)
                this.$refs.table.rowLoading(false)
            })
        },
        provider(data){
            return FirmOperationsApi.Contact.Table({PaginationRequestModel:data,FirmId:this.firm.Id})
        }
    }
}
</script>

<style>

</style>